import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmartireComponent } from './smartire/smartire.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { UrlModule, I18nModule, ConfigModule, CmsConfig, AuthGuard } from '@spartacus/core';
import { MediaModule, IconModule } from '@spartacus/storefront';
import { ReactiveFormsModule } from '@angular/forms';
import { SecureGuard } from 'src/app/services/Guards/secure.service';



@NgModule({
  declarations: [
    SmartireComponent
  ],
  imports: [
    CommonModule,
    MediaModule,
    IconModule,
    UrlModule,
    I18nModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    RouterModule,
    ReactiveFormsModule,
    ConfigModule.withConfig({
      cmsComponents: {
        KbSmartTireFlexComponentt: {
          component: SmartireComponent,
          guards: [SecureGuard]
        },
      }
    } as CmsConfig)
  ]
})
export class SmartireRoiModule { }
